import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { THREADS_NEW_PROFILE_SCOPES } from 'constants/socialLogin';

export const META_NETWORKS: number[] = [TYPE.FACEBOOK, TYPE.INSTAGRAM];

export const isMetaSafeConnectEligible = (
  pageType: number | null | undefined,
): boolean => pageType != null && META_NETWORKS.includes(pageType);

export const getDefaultScopesByPageType = (pageType: number) => {
  if (pageType === TYPE.THREADS) {
    return THREADS_NEW_PROFILE_SCOPES;
  }

  return [];
};
